export const ALLOWED_FILE_TYPES = '.doc, .docx, application/pdf, .jpg, .jpeg, .png, application/msword, image/jpg, image/jpeg, image/png'
